export default __webpack_public_path__ + "static/media/BBF-logo-round-white.decb0a34.svg";